<template>
  <v-dialog
    v-model="isOpen"
    persistent
    max-width="600px">
    <material-card
      :title="title"
      color="primary">
      <v-form
        ref="form"
        v-model="validForm"
        autocomplete="off"
        role="presentation">
        <v-container grid-list-md>
          <v-layout wrap>
            <core-field
              v-for="field in visibleFields"
              :key="field.name"
              :field="field"
              v-model="item[field.name]" />
          </v-layout>
        </v-container>
      </v-form>

      <v-flex
        xs12
        text-right>
        <v-btn
          class="mx-1 font-weight-light"
          color="success"
          @click="close()"
        >Close</v-btn
        >

        <v-btn
          v-if="$can('upsert', entityName)"
          :disabled="!validForm || loading"
          class="mx-1 font-weight-light"
          color="purple"
          @click="save()"> {{ isNew ? 'Save' : 'Update' }} </v-btn>

      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>

import validators from '@/utils/validators'
import { upperFirst as uf } from 'lodash'

const { upsert, getDetail } = require('@/api/base_entity')

export default {
  props: {
    config: { type: Object, default () {} },
    open: { type: Boolean, default: false },
    itemId: { type: Number, default: null }
  },
  data () {
    return {
      loading: false,
      validForm: false,
      validators,
      entityName: this.config.entityName,
      fields: this.config.fields,
      item: {}
      // roles: ['Administrator', 'Provider', 'Guest'],
      // statuses: ['Active', 'Disabled']
    }
  },
  computed: {
    isOpen () {
      return this.open
    },
    isNew () {
      return !this.itemId
    },
    title () {
      return this.isNew ? 'New ' + uf(this.entityName) : (this.readonly ? uf(this.entityName) + ' Details' : 'Edit ' + uf(this.entityName))
    },
    readonly () {
      return !this.$can('upsert', this.entityName)
    },
    visibleFields () {
      return this.fields.filter(f => f.visible ? f.visible(this.item, this) : true)
    }
  },
  watch: {
    open (v) {
      if (v && !this.isNew) {
        this.getData()
      } else {
        this.$refs.form.reset()
      }
    }
  },
  methods: {
    async getData () {
      this.item = await getDetail(this.entityName, { id: this.itemId })
    },
    close () {
      this.$emit('close')
    },
    checkSave () {
      return !this.isNew
    },
    save () {
      this.loading = true
      upsert(this.entityName, this.item)
        .then(data => {
          this.$store.dispatch('app/openSnackbar', {
            message: uf(this.entityName) + ' updated correctly',
            color: 'success'
          })
          const newItem = JSON.parse(JSON.stringify(data.data))
          this.$root.$emit('update_' + this.entityName, newItem)
          // this.$store.dispatch('app/close' + uf(this.entityName) + 'Dialog')
          this.close()
        })
        .catch(e => {
          this.$store.dispatch('app/openSnackbar', {
            message: 'An Error occurred during the ' + uf(this.entityName) + ' update. ' +
              e.response.data.message,
            color: 'error'
          })
        })
        .finally (() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
